<div class="align-items-center d-flex vh-100">
  <div class="container m-auto">
    <div [attr.id]="'route-' + route">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
